import React, { Component } from 'react';
import { Router, Route, browserHistory } from 'react-router';
import { auth } from 'firebase';

import App from '../../App';
import Home from '../Pages/Home';
import Books from '../Books/Books';
import Add from '../Books/Add';
import Admin from '../Pages/Admin';
import Keywords from '../Pages/Keywords';
import Keyword from '../Pages/Keyword';
import NotFound from '../Pages/NotFound';

// Check user is authenticated and if not redirect to login page
function requireAuth(nextState, replace) {
  if (!auth().currentUser) {
    replace({
      pathname: '/admin'
    })
  }
}

class AppRouter extends Component {
  render () {
    return (
      <Router history={browserHistory}>
        <Route component={App}>
          <Route path="/" component={Home} />
          <Route path="books" component={Books} />
          <Route path="books/add" component={Add} onEnter={requireAuth} />
          <Route path="keywords" component={Keywords} />
          <Route path="keywords/:keyword" component={Keyword} />
          <Route path="admin" component={Admin} />
          <Route path="*" component={NotFound} />
        </Route>
      </Router>
    );
  }
}

export default AppRouter;



/** WEBPACK FOOTER **
 ** ./src/components/Router/Router.js
 **/